import * as d3 from "d3";
import _ from "underscore";

//const swoopz = require("./swoopy");

d3.selection.prototype.tspans = function(lines, lh) {
    return this.selectAll('tspan')
        .data(lines)
        .enter()
        .append('tspan')
        .text(function(d) { return d; })
        .attr('x', 0)
        .attr('dy', function(d,i) { return i ? lh || 15 : 0; });
};

d3.wordwrap = function(line, maxCharactersPerLine) {
    var w = line.split(' '),
        lines = [],
        words = [],
        maxChars = maxCharactersPerLine || 40,
        l = 0;
    w.forEach(function(d) {
        if (l+d.length > maxChars) {
            lines.push(words.join(' '));
            words.length = 0;
            l = 0;
        }
        l += d.length;
        words.push(d);
    });
    if (words.length) {
        lines.push(words.join(' '));
    }
    return lines;
};

export function lineChart(parentElement, chartId, data, incWidth, incHeight, incDataKeys, incStaticData, incAnnotations){
	var self = {};
    var margin = (incWidth<375)? {top: 45, right:60, bottom: 30, left: 50}:{top: 45, right:80, bottom: 30, left: 70};
    var width = incWidth - margin.left-margin.right;
    var height = incHeight - margin.top - margin.bottom;
    var isAnimating = false;
    var chart;
    var parent;
    var linesG;
    var colorLines;
    var data;
    var currentIndex;
    var currentChapter;
    var chapterColor;

    const annotations = incAnnotations;
    
    const dataKeys = incDataKeys;

    const greenTipsData = incStaticData.map(function(x) {
    	return x.greentip;
    });

    const blue = "#0F4B91";
    const green = "#799A3D";
    const purple = "#863375";
    const darkPurple = "#3E1052";

	const x = d3.scaleTime()
		   .rangeRound([0, width]);

	const y = d3.scaleLinear()
		   .rangeRound([height, 0]);

    const formatDate = d3.timeFormat("%Y");

	const bisectDate = d3.bisector(function(d) { return d.x; }).left;

	const line = d3.line()
	  .x(function(d) { return x(d.x); })
	  .y(function(d) { return y(d.y); });

	self.xDomain = function(incDomain) {
		x.domain(incDomain);
	}

	self.yDomain = function(incDomain) {
    	y.domain(incDomain);
	}

	function selectVoronoiColor(tech) {
		let color;
        switch (tech) {
          case "ehr":
            color = "#0F4B91";
            break;
          case "internet-usage":
            color = "#863375";
            break;
          case "household-computers":
            color = "#F28C08";
            break;
          case "household-phones":
            color = "#FFCF03";
            break;
          case "physician-satisfaction":
            color = "#B9C932";
            break;
          default:
            console.log("Sorry, we are out of fucks to give.");
        }

        return color;
    }

	function getCurrentChapterColor(id) {
		let chapterColor;
	    switch (currentChapter){
	    	case 1:
				chapterColor=purple;	
			    break;
	    	case 2:
				chapterColor=selectVoronoiColor(id);	
			    break;
		    case 3:
				chapterColor=green;	
			    break;
	    }
	    return chapterColor;
	}

    function getPreviousId(name){
    	const found = (_.findIndex(dataKeys, {name: name}))+1;
    	const id = dataKeys[found].name;
    	return id;
    };

    function rounded_rect(x, y, w, h, r, tl, tr, bl, br) {
        var retval;
        retval  = "M" + (x + r) + "," + y;
        retval += "h" + (w - 2*r);
        if (tr) { retval += "a" + r + "," + r + " 0 0 1 " + r + "," + r; }
        else { retval += "h" + r; retval += "v" + r; }
        retval += "v" + (h - 2*r);
        if (br) { retval += "a" + r + "," + r + " 0 0 1 " + -r + "," + r; }
        else { retval += "v" + r; retval += "h" + -r; }
        retval += "h" + (2*r - w);
        if (bl) { retval += "a" + r + "," + r + " 0 0 1 " + -r + "," + -r; }
        else { retval += "h" + -r; retval += "v" + -r; }
        retval += "v" + (2*r - h);
        if (tl) { retval += "a" + r + "," + r + " 0 0 1 " + r + "," + -r; }
        else { retval += "v" + -r; retval += "h" + r; }
        retval += "z";

        return retval;
    };

    function formatHoverText(d) {
    	var formattedValue;

		switch (currentIndex) {
			case 0:
			case 1:
			  formattedValue = d + "%";
	          break;
	        case 2:	          
	          formattedValue =  d;
	          break;
	        case 3:	          
	          formattedValue =  "$"+(d/1000)+"k";
	          break;
	        case 4:	          
	          formattedValue =  d + " years";
	          break;
	        case 5:	          
	          formattedValue =  d + " min";
	          break;
	        default:	          
	          formattedValue = d + "%";
	          break;
	    }
	    return formattedValue;
    }

	function xHoverMousemove() {

		var overlay = d3.select(".overlay").node();

		let chapterColor;
		if (currentChapter !== 2) {
			chapterColor = getCurrentChapterColor();
		} else {
			if (currentIndex == 7) {
				chapterColor = "#0F4B91";
			} else if (currentIndex == 8) {
				chapterColor = "#B9C932";
			}
		}
		var focus = d3.select(".focus");
	    

	    focus.select("text").style("opacity", 1);
	    focus.select("rect").style("fill", chapterColor).style("opacity",1);
	    focus.select("circle")
	    .style("fill", chapterColor)
	    .style("stroke", chapterColor)
	    .style("fill-opacity", 0.3)
	    .style("stroke-opacity", 1);

	    var x0 = x.invert(d3.mouse(overlay)[0]),
	        i = bisectDate(data, x0, 1),
	        d0 = data[i - 1],
	        d1 = data[i],
	        d = x0 - d0.x > d1.x - x0 ? d1 : d0;
	    
	    focus.attr("transform", "translate(" + x(d.x) + "," + y(d.y) + ")");
	    focus.select(".hover-date").text(formatDate(d.x)).style("opacity", 1);
	    focus.select(".hover-value").classed("futura-demi", true).text(" " + formatHoverText(d.y)).style("opacity", 1);


	    const bbox = focus.select("text").node().getBBox();
	    focus.select("rect")
	      .style("fill", chapterColor)
		  .attr("x", bbox.x-5)
		  .attr("y", bbox.y)
		  .attr("width", bbox.width+10)
		  .attr("height", bbox.height)
	      .style("opacity",0.8);
	    if (x(d.x) >= width-150) {	
	    	focus.select("text").attr("x", -(bbox.width+25))
	    	focus.select("rect").attr("x", -(bbox.width+30))
	    } else {
	    	focus.select("text").attr("x", 20);
	    	focus.select("rect").attr("x", 15);	
	    }
	};

	function mouseover(d) {
		//TODO: refactor this and xHoverMousemove() - this is a stupidly verbose way to do this.

        var fill;
        const focus = d3.select(".focus");
        focus.style("display", null);
        switch (d.data.tech) {
          case "ehr":
            fill = "#0F4B91";
            break;
          case "internet-usage":
            fill = "#863375";
            break;
          case "household-computers":
            fill = "#F28C08";
            break;
          case "household-phones":
            fill = "#FFCF03";
            break;
          case "physician-satisfaction":
            fill = "#B9C932";
            break;
          default:
            console.log("Sorry, we are out of fucks to give.");
        }

        
        focus.attr("transform", "translate(" + x(d.data.x) + "," + y(d.data.y) + ")");
	    
	    focus.select("text").style("opacity", 1);
	    focus.select("rect").style("fill", fill);
	    focus.select("circle")
	    .style("fill", fill)
	    .style("stroke", fill)
	    .style("fill-opacity", 0.5)
	    .style("stroke-opacity", 1);

	    focus.select(".hover-date").text(formatDate(d.data.x));
	    focus.select(".hover-value").text(" " + d.data.y);
	}

	self.newData = function(incNewData) {
		data = incNewData;
	};

	self.newCurrentIndex = function(incNewIndex) {
		currentIndex = incNewIndex;
	};

	self.newCurrentChapter = function(incNewChapter) {
		currentChapter = incNewChapter;
	};

	self.updateWithNewData = function(incNewData, incNewIndex, incNewChapter) {
		self.newData(incNewData);
		self.newCurrentIndex(incNewIndex);
		self.newCurrentChapter(incNewChapter);		
	}

	self.data = function(newData, newIndex, newChapter, id) {
		console.warn(newData, newIndex, newChapter, id);
	    if (!arguments.length) {
	      return data;
	    }

	    if (newIndex > currentIndex || currentIndex == undefined) {
		    data = newData;
		    if (currentIndex == undefined) {
		    	currentIndex = 0;
		    } else {
			    currentIndex = newIndex;
		    }
		    currentChapter = newChapter;

		    // self.drawAxes();

		    if (currentChapter !== 2 && currentIndex !== 6) {
		    	self.drawAxes();
			    self.appendLines(data, id, true);
			} else if (currentIndex == 6){
				self.drawAxes();
				self.drawVoronoi(data);
			} else if (currentIndex == 7 || currentIndex == 8){
				console.warn('section 7 or 8');
			} else {
				console.warn("you are in section: " + currentIndex);
			}
		} else if (newIndex < currentIndex && newIndex !== 0) {
			console.warn("You should see this if you scroll up");
			data = newData;
		    currentIndex = newIndex;
		    currentChapter = newChapter;
		} else if (newIndex < currentIndex && newIndex == 0) {
			data = newData;
		    currentIndex = 0;
		    currentChapter = 1;
		    console.warn('data');
		    console.warn(data)
		    self.drawAxes();
			self.appendLines(data, id, true);
		} else if (currentIndex == 0) {
			data = newData;
		    currentIndex = 0;
		    currentChapter = 1;
		    console.warn('data');
		    console.warn(data)
		    self.drawAxes();
			self.appendLines(data, id, true);
		} else {
			console.warn("something went wrong... you are at currentIndex: " + currentIndex);
		}

	    return this;
	};

    self.removeLine = function(currentName){ //TODO: rename this - it fines the PREVIOUS line, and removes THAT, it doesn't just remove the current line

    	/*

			NOTE: if this causes too many bugs, revert back to just removing the path instead of animating it to
			`opacity: 0` first. Cheers!

    	*/
    	const id = getPreviousId(currentName);

		d3.select("#"+id).select("g").select("path").transition().duration(500).style("stroke-opacity", 0);

    	function removal() {
    		d3.select("#"+id).remove();
	    	self.removePreviousClipPath(currentName);
	    }

	    window.setTimeout(removal, 500);

    };

    self.removePreviousChapterLines = function(chapter) {
    	//This currently just calls another method, the idea is might want to do some additional work here at some point
	    self.removeChapterLines(chapter)   	
    };

    self.removeChapterLines = function(chapter) {
	    d3.selectAll(".ch-" + chapter).remove();
    };

    self.removePreviousClipPath = function(name) {
    	const id = getPreviousId(name);
    	d3.select("#line-clip-path-"+id).remove();
    };

    self.removeClipPaths = function(name) {
    	d3.selectAll("clipPath").remove();
    };

    self.highlightLine = function(name) {
    	d3.select("#"+name).select("g").select("path").transition().duration(500).style("stroke-opacity", 1);
    };

	self.appendLines = function(data, id, highlightRecent) {
		self.removeAnnotations();
		if (highlightRecent) {
			d3.selectAll(".lineG").select("path").transition().duration(2000).style("stroke-opacity", .2);
		}

		self.appendClipPath(data, id);
		self.appendLineGroup(data, id);
		self.revealCurtain(id);
//TODO:
/*

	GET THIS SHIT WORKING RIGHT.

*/
		
		self.appendAnnotations();
	};

	self.removeAnnotations = function() {
		d3.selectAll(".annotations").remove();
	}

	function appendAnnotation(d) {
		const annotation = d3.select("#annotationLayer").append("g").attr("class", "annotations");

		if (d.flip == true) {
		    annotation.attr("transform", "translate(" + (x(d.x)-5) + "," + ((y(d.y)-20)-5) + ")");
		} else {
		    annotation.attr("transform", "translate(" + x(d.x) + "," + (y(d.y)-20) + ")");
		}

	    const invisibleText = annotation.append("text").attr("text-anchor", d.flip == true ? "end" : "start").text(d.text).style("opacity", 0);
	    const bbox = invisibleText.node().getBBox();

		const bboxWidth = bbox.width+10;
		const bboxHeight = bbox.height+0.5;
		const bl = d.flip == true ? 5 : 0;
		const br = d.flip == true ? 0 : 5;

		const annoShape = annotation.append("path")
		  .attr("d", rounded_rect(bbox.x, bbox.y, bboxWidth, bboxHeight, 5, 5, 5, bl, br))
		  .style("fill", purple)
		  .style("fill-opacity", 0)
		  .style("stroke-opacity", 0);

		const annoTip = annotation.append("polygon")
		  .style("fill", purple)
  		  .style("fill-opacity", 0)
  		  .style("stroke-opacity", 0)
		  .attr("points", d.flip == true ? "0,5.5 10,15 10,5.5" : "0,5.5 0,15 10,5.5");

		const annoText = annotation.append("text")
		  .style("fill", "white")
		  .style("fill-opacity", 0)
		  // .attr("dx", "5")
		  .attr("dx", d.flip == true ? (-(bbox.width)+5) : 5)
		  // .attr("text-anchor", d.flip == true ? "end" : "start")
		  .text(d.text);

		annoShape.transition().duration(3000).style("fill-opacity", 0.8);
		annoTip.transition().duration(3000).style("fill-opacity", 0.8);
		annoText.transition().delay(100).duration(3000).style("fill-opacity", 0.8);
	};

	self.appendAnnotations = function() {

		// const swoopy = d3.swoopyDrag()
		//     .x(function(d){ return x(d.date) })
		//     .y(function(d){ return y(d.value) })
		//     .draggable(false)
		//     .annotations(annotations[currentIndex].annotations);
	
		// window.setTimeout(appendAnnotationBBox, 0);
		// const swoopySelection = d3.select("#"+chartId).append('g').attr("class", "annotations").call(swoopy);

		// swoopySelection.selectAll('path').attr('marker-end', 'url(#arrow)');
		
		console.warn("appendAnnotations");
		console.warn("appendAnnotations currentIndex is -----" + currentIndex);
		annotations[currentIndex].annotations.forEach(function(d) {
			console.log(y.domain()); 
			console.log(d.text)
			appendAnnotation(d);
		});		

	}

	self.appendLineGroup = function(data, id) {

	    switch (currentChapter){
	    	case 1:
				chapterColor=purple;	
			    break;
	    	case 2:
				chapterColor=selectVoronoiColor(id);	
			    break;
		    case 3:
				chapterColor=green;	
			    break;
	    }

	    linesG = chart.select(".lines").append("g")
	        .attr("class", "index-" + currentIndex + " ch-" + currentChapter)
	        .attr("id", id);

	    colorLines = linesG
	      .append("g")
	        .attr("class", "lineG " + id)
	        .attr("clip-path", "url(#line-clip-path-" + id + ")")
	      .append("path")
			.datum(data)
		    .attr("class", "line index-" + currentIndex + " ch-" + currentChapter)
		    .attr("d", line)
		    .attr("stroke", chapterColor)
		    .style("stroke-width", 5)
		    .style("stroke-linecap", "round");

	}

	self.appendClipPath = function(data, id) {
		const defs = d3.select("defs");
        const clip = defs.append("clipPath").attr("id", "line-clip-path-" + id);
		clip.append("rect")
		    .attr("x", x(data[0].x))
		    .attr("width", 0)
		    .attr("height", height);
	}

	self.revealCurtain = function(id) {
	  const clippingPath = "#line-clip-path-" + id;
	  const curtain = d3.select(clippingPath).select('rect');

      curtain.transition()
        .duration(2000)
        .attr("width", width);

	};

	self.closeCurtain = function(id) {
	  //TODO: figure out some way to get this to work
	  // basically, so when scrolling back down, lines still animate
	  const clippingPath = "#line-clip-path-" + id;
	  const curtain = d3.select(clippingPath).select('rect');

      curtain.attr("width", 0);
	}

	self.draw = function(parentElement, chartId) {	//chartId == `.force-chart`
	    d3.select('.chart-container').remove();
	    d3.select('#'+chartId).remove();
	    d3.select('#chart').select("svg").remove(); //ugh. Messed something up here

	    parent = d3.select(parentElement).append('div').classed('chart-container noselect ' + chartId, true)
		    .style("position", 'relative')
		    .style("width", width + margin.left + margin.right+'px')
		    .style("height", height + margin.top + margin.bottom+'px')
		    .style("margin", '0 auto');

		chart = parent.append("svg")
	        .attr('id', chartId)
	        .attr("width", width + margin.left + margin.right)
	        .attr("height", height + margin.top + margin.bottom)
	      .append("g")
	        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

	    chart.append('defs');

	    chart.append("g")
	      .attr("class", "axis axis--x")
	      .attr("transform", "translate(0," + height + ")")
		
		chart.append("g")
	      .attr("class", "axis axis--y")

	    chart.append("g").attr("class", "lines");

	    chart.append("line").attr("id", "bottom-line").attr("x1", 0).attr("x2",width).attr("y1", height+2).attr("y2", height+2)
	      .attr("stroke", darkPurple)
	      .attr("stroke-width", "4px")
	      .style("opacity", 0);

	    const leftYear = chart.append("g").attr("transform", "translate(0,"+(height+4)+")").attr("id", "leftYear").style("opacity", 0);
	    const rightYear = chart.append("g").attr("transform", "translate("+(width-50)+","+(height+4)+")").attr("id", "rightYear").style("opacity", 0);

	    leftYear.append("rect").attr("height", 20).attr("width", 50).style("fill", darkPurple);
	    rightYear.append("rect").attr("height", 20).attr("width", 50).style("fill", darkPurple);
	    leftYear.append("text").attr("dy", 13).attr("dx", 8).attr("fill", "white").text("1890");
	    rightYear.append("text").attr("dy", 13).attr("dx", 9).attr("fill", "white").text("2016");

	    const greenTipsGroup = chart.append("g").attr("id", "greenTipsG").attr("transform", "translate("+width+","+0+")");

	    //this is new for new purple tooltip styling
	    const annotationLayer = chart.append("g").attr("id", "annotationLayer");

	    const focus = chart.append("g").attr("class", "focus").style("display", "none");
	    focus.append("circle")
	      .attr("r", 4.5)
	      .style("stroke-width", 3);
	    focus.append("rect")
	      .attr("x", 15)
	      .attr("y", -12)
	      .attr("height", 25)
	      .attr("width", 100)
	      .attr("rx", 5)
	      .attr("ry", 5);
	    const text = focus.append("text").attr("x", 25).attr("dy", ".35em");
	    text.append("tspan").attr("class", "hover-date");
	    text.append("tspan").attr("class", "hover-value");

	    chart.append('marker')
		  .attr('id', 'arrow')
		  .attr('viewBox', '-10 -10 20 20')
		  .attr('markerWidth', 20)
		  .attr('markerHeight', 20)
		  .attr('orient', 'auto')
		 .append('path')
		  .attr('d', 'M-6.75,-6.75 L 0,0 L -6.75,6.75')

	    //invisible overlay rect
	    chart.append("rect")
	      .attr("class", "overlay")
  	      .attr("width", width)
	      .attr("height", height);
	    
	    chart.select(".overlay").on("mouseover", function() { focus.style("display", null); })
	      .on("mouseout", function() { focus.style("display", "none"); })
	      .on("mousemove", xHoverMousemove);

	    window.setTimeout(function() {
		    d3.select("#leftYear").transition().duration(2000).style("opacity",1);
		    d3.select("#rightYear").transition().duration(2000).style("opacity",1);
		    d3.select("#bottom-line").transition().duration(2000).style("opacity",1);
		},0);

	};

    self.resizeAndFadeOutLine = function(id) {
    	// TODO:
    	/*
			
			Yeah, this is pretty fucked up. Refactor this bullshit away if possible.

    	*/ 

    	if (currentIndex==11) { //yeah, this breaks the abstraction barrier, but I just want it to work right now
    		x.domain([new Date("01/01/1940"), new Date("01/01/2016")]);
    		y.domain([0,20]);
    	} else if (currentIndex==10){
    		x.domain([new Date("01/01/1975"), new Date("01/01/2016")]);
    	}

    	if (id == "physician-growth") {
    		y.domain([0, 3500]);
    	}

    	if (id == "administrative-roles") {
    		y.domain([0,3500]);
    	}

    	const line = d3.line()
		  .x(function(d) { return x(d.x); })
		  .y(function(d) { return y(d.y); });

    	d3.select("#"+id).select("path").transition().duration(2000).attr("d", line).style("stroke-opacity", 0.2);
    };

    self.resizeAndFadeInLine = function(id) {
    	if (currentIndex==9 || currentIndex==10) { //yeah, this breaks the abstraction barrier, but I just want it to work right now
    		x.domain([new Date("01/01/1975"), new Date("01/01/2016")]);
    	}

    	if (currentIndex==9) {
    		y.domain([0, 160]);
    	}
    	if (currentIndex==10) {
    		y.domain([0, 3500]);
    	}

    	d3.select("#"+id).select("path").transition().duration(2000).attr("d", line).style("stroke-opacity", 1);
    };

	self.drawAxes = function(){

	  const ticks = document.querySelectorAll('.tick');
	  if(ticks.length == 0) {
		// const g = chart.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
		const g = d3.select("#"+chartId).select('g');

	    // x.domain(d3.extent(data, function(d) { return d.x; }));
	    // y.domain(d3.extent(data, function(d) { return d.y; }));
	    switch (currentChapter){
	    	case 1:
	    	  changeYear(1890);
	    	  if (currentIndex == 0 || currentIndex == 1) {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, 100]);
				// changeYear(1890);
			  } else if (currentIndex == 2) {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, 6]);
				// changeYear(1890);
			  } else if (currentIndex == 3) {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, 10000]);
				// changeYear(1890);
			  } else if (currentIndex == 4) {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, 80]);
				// changeYear(1890);
	    	  } else {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, d3.max(data, function(d) { return d.y; })]);
	    		// changeYear(1890);
	    	  }
		    	break;
	    	case 2:
		    	y.domain([0, 100]);
	    	    if (currentIndex == 6) {
	    	    	console.log("foo");
			    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
			    	changeYear(1890);
			    } else {
			    	console.log("bar");
			    	x.domain([new Date("01/01/1991"), new Date("01/01/2016")]);
			    	changeYear(1991);
			    }
		        break;
		    case 3:
			    if (currentIndex == 9) {
			    	x.domain([new Date("01/01/1975"), new Date("01/01/2016")]);
    		    	y.domain([0, 160]);
    		    	changeYear(1975);
    		    } else if (currentIndex == 10) {
			    	x.domain([new Date("01/01/1975"), new Date("01/01/2016")]);
    		    	y.domain([0, 3500]);
    		    	changeYear(1975);
    		    } else {
			    	x.domain([new Date("01/01/1940"), new Date("01/01/2016")]);
    		    	y.domain([0, 20]);
    		    	changeYear(1940);
    		    } 
			    break;
			default:
				x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    }



	 	  // d3.select(".axis.axis--x")
	    //   .call(d3.axisBottom(x)
	    //   	// .tickFormat("")
	    //   	.tickSize(-height, 0, 0));

	    //   d3.select(".axis.axis--y")
	    //   .call(d3.axisLeft(y).tickSize(-width, 0, 0)).selectAll("text").attr("x", -10).style("text-anchor", "end");
		var formatYTicks;

		switch (currentIndex) {
	        case 2:	          
	          formatYTicks =  function(d) { return (d); };
	          break;
	        case 3:	          
	          formatYTicks =  function(d) { return "$"+(d/1000)+"k"; };
	          break;
	        case 4:	          
	          formatYTicks =  function(d) { return d + " yrs"; };
	          break;
	        case 5:	          
	          formatYTicks =  function(d) { return d + " min"; };
	          break;
	        default:	          
	          formatYTicks = function(d) { return (d) + "%"; };
	          break;
	    }

		var t0 = d3.select("#"+chartId).transition().duration(100);
	    var t1 = t0.transition().duration(1000);

	    t1.selectAll(".axis.axis--y").call(d3.axisLeft(y)
	    	.ticks(5)
	    	.tickFormat(formatYTicks)
	    	.tickSize(-width, 0, 0))
	    .selectAll("text").attr("x", -10).style("text-anchor", "end");
	    t1.selectAll(".axis.axis--x").call(d3.axisBottom(x)
	    	// .ticks(5)
	    	.tickArguments([d3.timeYear.every(10)])
	    	.tickFormat("")
	    	.tickSize(-height, 0, 0));
	   } else {
	   	 self.animateAxes();
	   }
	}

function changeYear(newYear) {
	console.warn(d3.select("#leftYear"));
	d3.select("#leftYear").select("text").transition().duration(2000)
    .tween("text", function(d) {
      console.log(d);
      let thisText = this.textContent;
      var i = d3.interpolate(thisText, newYear);
      return function(t) {
        d3.select("#leftYear").select("text").text(Math.round(i(t)));
      };
    });
};


self.animateAxes = function() {

		var formatYTicks;

		switch (currentIndex) {
	        case 2:	          
	          formatYTicks =  function(d) { return (d); };
	          break;
	        case 3:	          
	          formatYTicks =  function(d) { return "$"+(d/1000)+"k"; };
	          break;
	        case 4:	          
	          formatYTicks =  function(d) { return d + " yrs"; };
	          break;
	        case 5:	          
	          formatYTicks =  function(d) { return d + " min"; };
	          break;
	        default:	          
	          formatYTicks = function(d) { return (d) + "%"; };
	          break;
	    }

		var t0 = d3.select("#"+chartId).transition().duration(100);

	    switch (currentChapter){
	    	case 1:
	    	  changeYear(1890);
	    	  if (currentIndex == 0 || currentIndex == 1) {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, 100]);
				// changeYear(1890);
			  } else if (currentIndex == 2) {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, 6]);
				// changeYear(1890);
			  } else if (currentIndex == 3) {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, 10000]);
				// changeYear(1890);
			  } else if (currentIndex == 4) {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, 80]);
				// changeYear(1890);
	    	  } else {
		    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    		y.domain([0, d3.max(data, function(d) { return d.y; })]);
	    		// changeYear(1890);
	    	  }
		    	break;
	    	case 2:
		    	y.domain([0, 100]);
	    	    if (currentIndex == 6) {
	    	    	console.log("foo");
			    	x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
			    	changeYear(1890);
			    } else {
			    	console.log("bar");
			    	x.domain([new Date("01/01/1991"), new Date("01/01/2016")]);
			    	changeYear(1991);
			    }
		        break;
		    case 3:
			    if (currentIndex == 9) {
			    	x.domain([new Date("01/01/1975"), new Date("01/01/2016")]);
    		    	y.domain([0, 160]);
    		    	changeYear(1975);
    		    } else if (currentIndex == 10) {
			    	x.domain([new Date("01/01/1975"), new Date("01/01/2016")]);
    		    	y.domain([0, 3500]);
    		    	changeYear(1975);
    		    } else {
			    	x.domain([new Date("01/01/1940"), new Date("01/01/2016")]);
    		    	y.domain([0, 20]);
    		    	changeYear(1940);
    		    } 
			    break;
			default:
				x.domain([new Date("01/01/1890"), new Date("01/01/2016")]);
	    }


	    
	    // console.warn('self.animateAxes()');

	    var t1 = t0.transition().duration(1000);

	    t1.selectAll(".axis.axis--y").call(d3.axisLeft(y)
	    	.ticks(5)
	    	.tickFormat(formatYTicks)
	    	.tickSize(-width, 0, 0))
	    .selectAll("text").attr("x", -10).style("text-anchor", "end");
	    t1.selectAll(".axis.axis--x").call(d3.axisBottom(x)
	    	// .ticks(5)
	    	.tickArguments([d3.timeYear.every(10)])
	    	.tickFormat("")
	    	.tickSize(-height, 0, 0));
	  
	}

	self.drawVoronoi = function(voronoiData) {

		const newVoronoiData = [];
	    voronoiData.forEach(function(d) {
	    	const id = d[0].tech;
	    	if (id !== "physician-satisfaction") {
	  	  	    self.appendLines(d, id, false);
		    }
	    });

	    // self.drawVoronoiPolygons(voronoiData);


	      self.drawVoronoiPolygons(voronoiData);

	    

	}

	self.drawVoronoiPolygons = function(voronoiData) {
	    d3.selectAll(".voronoi").remove();
	    let voronoi = d3.voronoi()
	      .x(function(d) { return x(d.x); })
	      .y(function(d) { return y(d.y); })
	      // .extent([[margin.left, margin.top],[width +margin.left, height +margin.top]]);
	      // .extent([[margin.left, margin.top],[width+margin.left, height+margin.top]]);
	      .extent([[0,0],[width , height]]);

		const newVoronoiData = [];
	    voronoiData.forEach(function(d) {
	    	const id = d[0].tech;
	    	if (id !== "physician-satisfaction") {
	  	  	    d.forEach(function(datum) {
					newVoronoiData.push(datum);
				});
		    }
	    });

	    const svg = d3.select("#"+chartId);
        const g = svg.select("g");

	    var voronoiGroup = g.append("g")
          .attr("class", "voronoi");


        voronoiGroup.selectAll("path")
          .data(voronoi.polygons(newVoronoiData))
          .enter().append("path")
          .attr('class','polygon')
          .attr("d", function(d) { return d ? "M" + d.join("L") + "Z" : null; })
          // .style("stroke", "orange")
          .style("opacity", "0.3")
          .style("fill", "none")
          .style("pointer-events", "all")
          .on("mouseover", mouseover);

	}

	self.zoomVoronoi = function(voronoiData, incOpacity) {
		//do nothing, for now
		//eventually, this should transition existing paths into new, "zoomed in" paths

		self.removeAnnotations();

		var lineOpacity;

		if (incOpacity == undefined) {
			lineOpacity = 0.2;
		} else {
			lineOpacity = incOpacity;
		}

		d3.selectAll("clipPath").select("rect").attr("x", 0);
	    voronoiData.forEach(function(d) {
	    	const id = d[0].tech;
	    	if (id !== "physician-satisfaction") {
	    	  if (id !== "ehr") {
		  	  	d3.select("#"+id).select("path").transition().duration(2000).attr("d", line).style("stroke-opacity", lineOpacity);
		  	  } else {
		  	  	d3.select("#"+id).select("path").transition().duration(2000).attr("d", line).style("stroke-opacity", 1);
		  	  }

		    }

	    });
		self.appendAnnotations();
	};

	self.zoomSingleVoronoi = function(voronoiData, incId) {
		voronoiData.forEach(function(d) {
			const id = d[0].tech;
	    	if (id == incId) {
	    		d3.select("#"+id).select("path").transition().duration(2000).attr("d", line).style("stroke-opacity", 0.2);
	    	}
		});
	}

	self.removeVoronoi = function() {
		d3.select("svg#force-chart").selectAll(".polygon").remove();
		d3.select(".voronoiParent").remove();
		//TODO: the focus is messed up because it is reappended each time the voronoi section is scrolled to.
		// Figure something out to et this to place nice with the rest of the x-hover!!!

        // d3.select(".focus").select("circle").style("fill-opacity", 0).style("stroke-opacity", 0);
        // d3.select(".focus").select("text").style("opacity", 0);
        // d3.select(".focus").select("rect").style("opacity", 0);

        // Nota Bene: maybe the best way to get this to work is to switch off hover function on specific index?
	};

	self.fadeInLine = function(id) {
		d3.select("#"+id).select("path").transition().duration(2000).style("stroke-opacity", 1);
	};

	self.fadeLine = function(id) {
		d3.select("#"+id).select("path").transition().duration(2000).style("stroke-opacity", 0.2);
	};

	function getLastItem(array) { 
        return _.last(array);
    };


    var physicianGrowthYValue;

    function getGreenTipYValue(data) {
    	if (currentIndex == 10) {
    		physicianGrowthYValue = getLastItem(data);
    	}
    	return getLastItem(data);
    }

    self.changePrevGreenTipOpacity = function() {
    	const tips = d3.selectAll(".green-tip");
    	const opacity = 0.2;
    	if (currentIndex !== 0) {
	    	tips.transition().duration(2000).style("opacity", opacity);
	    }
    }

	self.appendGreenTip = function(currentName, nudgeVal) {
		
		self.changePrevGreenTipOpacity(); //fade out all previous greentips
		
		var nudge;
		if (nudgeVal != undefined) {
			nudge = nudgeVal;
		} else {
			nudge = 0;
		}
		const yValue = getGreenTipYValue(data);

		const currentTip = d3.select("#greenTipsG")
		.append("g")
		.attr("class", "green-tip " + currentName)
		.style("fill-opacity", 0)
		.style("fill", green)
		.attr("transform", "translate("+5+","+(y(yValue.y)+nudge)+")")
		.append("text").tspans(function(d) {
	        return d3.wordwrap(greenTipsData[currentIndex], 10);  // break line after 15 characters
	    });

		currentTip.transition().delay(1500).duration(500).style("fill-opacity", 1);

	};

	self.removeAllGreenTips = function() {
		d3.selectAll(".green-tip").remove();
	};

	self.removeLastGreenTip = function(removeName, highlightName) {
		window.setTimeout(function() {
		  d3.select("#greenTipsG").select("."+removeName).remove();
		}, 500);
		d3.select("#greenTipsG").select("."+removeName).transition().duration(500).style("opacity", 0);
		d3.select("#greenTipsG").select("."+highlightName).transition().duration(500).style("opacity", 1);
	};

	self.moveGreenTip = function(incY) {
		console.log('boo');
		const tip = d3.select(".green-tip");
		if (currentIndex ==9) {
			tip.transition().duration(2000).attr("transform", "translate("+5+","+incY+")").style("opacity", 1);
		} else if (currentIndex == 10) {
			tip.transition().duration(2000).attr("transform", "translate("+5+","+incY+")").style("opacity", 0.2);
		}
	}

	self.movePhysiciansGrowthGreenTip = function() {
		const physGrowthYValue = y(150); //last value in `physician-growth.csv`
		console.warn("physGrowthYValue");
		console.log(physGrowthYValue);
		self.moveGreenTip(physGrowthYValue);
	};

	self.resize = function(_w, _h){
	    width = _w - margin.left - margin.right;
	    height = _h - margin.top - margin.bottom;

	    x.rangeRound([0, width]);
	    y.rangeRound([height, 0]);

	    self.draw(parentElement, chartId);

	    return self;
    }

	self.el= function() {
	  if (!arguments.length) {
	  	return d3.select(parentElement);
	  }
	  return this;
	};


    return self;
};


/** WEBPACK FOOTER **
 ** ./src/components/line-chart.js
 **/